import React from 'react';
import { Link } from 'react-router-dom';
import {
  CubeTransparentIcon,
  PhotoIcon,
  RocketLaunchIcon,
  Squares2X2Icon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

const CREATE_OPTIONS = [
  {
    title: 'Fungible Token',
    standard: 'VSC-7',
    desc: 'Create a token with name, symbol, supply, and metadata. Ready to trade instantly.',
    href: '/create/token',
    icon: CubeTransparentIcon,
    color: 'text-vextaris-blue',
  },
  {
    title: 'NFT Collection',
    standard: 'VSC-21',
    desc: 'Launch an NFT collection with royalties, metadata, and on-chain provenance.',
    href: '/nfts',
    icon: PhotoIcon,
    color: 'text-purple-400',
  },
  {
    title: 'Multi-Token Collection',
    standard: 'VSC-55',
    desc: 'Fungible and non-fungible tokens in one collection. Game items, loyalty points, mixed assets.',
    href: '/multi-token',
    icon: Squares2X2Icon,
    color: 'text-cyan-400',
  },
  {
    title: 'Presale',
    standard: 'VSC-LAUNCH',
    desc: 'Anti-rug escrow with soft/hard caps, auto-LP lock, and refund guarantees.',
    href: '/presales',
    icon: RocketLaunchIcon,
    color: 'text-green-400',
  },
];

export default function CreateHub() {
  return (
    <div>
      <div className="mb-10">
        <h1 className="text-4xl font-bold text-white mb-3">Create</h1>
        <p className="text-gray-400 text-lg">
          Launch assets on Vextaris using native VSC standards. Single operation, no smart contract deployment needed.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CREATE_OPTIONS.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.title}
              to={item.href}
              className="bg-vextaris-darker border border-gray-800 rounded-xl p-6 hover:border-vextaris-purple/50 transition-all group"
            >
              <div className="flex items-start justify-between mb-4">
                <Icon className={`w-8 h-8 ${item.color}`} />
                <span className="text-xs text-gray-600 bg-gray-800 px-2 py-1 rounded">{item.standard}</span>
              </div>
              <h3 className="text-white text-lg font-semibold mb-2 group-hover:text-vextaris-blue transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm mb-4">{item.desc}</p>
              <span className="inline-flex items-center text-sm text-gray-400 group-hover:text-vextaris-blue transition-colors">
                Get started <ArrowRightIcon className="w-4 h-4 ml-1" />
              </span>
            </Link>
          );
        })}
      </div>

      <div className="mt-8 bg-vextaris-darker border border-gray-800 rounded-xl p-6">
        <h3 className="text-white font-medium mb-2">Need something more complex?</h3>
        <p className="text-gray-500 text-sm mb-3">
          If you need multiple operations to execute atomically -- like launching a token AND creating a liquidity pool
          in one transaction -- use a <strong className="text-white">VIP (Vextaris Intent Program)</strong>.
        </p>
        <Link to="/programs" className="inline-flex items-center text-sm text-vextaris-blue hover:text-white transition-colors">
          Go to Programs <ArrowRightIcon className="w-4 h-4 ml-1" />
        </Link>
      </div>
    </div>
  );
}
